import { render, staticRenderFns } from "./Notifications.yaml?vue&type=template&id=ea3b2424&component"
import script from "./Notifications.yaml?vue&type=script&lang=ts&component"
export * from "./Notifications.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports